import { useState, useEffect } from 'react'
import { useRouter } from "../../hooks/router";
import { sing_in, check_email_req, autoSignInSubUser } from "../../server/requests";

import ErrorMessage from '../AlertMessage/ErrorMessage'
import Loading from '../Loading/Loading'
import { NavLink } from "react-router-dom";
import { generate_id, info_device, translateWord,crypt } from "../Util/util";

export default function Login({
    setPopUpTitles, configs, setIsGuest
}) {
    const router = useRouter()

    const [login, setLogin] = useState({
        email: '',
        password: '',
    })
    const [validate, setValidate] = useState(false)
    const [showErrorMessage, setShowErrorMessage] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [urlHelp, setUrlHelp] = useState('')
    const [signingIn, setSigningIn] = useState(false)


    useEffect(() => {
        setPopUpTitles('Login')
    }, []);

    const onChange = (e) => {

        const { name, value } = e.target;
        setLogin({ ...login, [name]: value });

    }

    const onSubmit = (e) => {

        e.preventDefault();

        let result

        if (localStorage.getItem('device_id')) result = localStorage.getItem('device_id')
        else {
            result = generate_id()
            localStorage.setItem('device_id', result)
        }

        let device_info = info_device()

        var body = {
            email: login.email,
            password: login.password,
            device_id: result,
            device_model: device_info.split(' ')[0],
            device_name: device_info.split(' ')[1]
        }

        if (login.email && login.password) {
            sing_in(body, res => {
                localStorage.clear()
                setIsGuest(false)
                localStorage.setItem('token', crypt('token', res))
                localStorage.setItem('root', crypt('root', JSON.stringify(body)))
                setSigningIn(true)
                autoSignInSubUser(router, null, () => setSigningIn(false))

            }, err => {
                if (err === "email not active") {
                    router.push('/auth/mail-verification?m=' + err + '&type=error&mail=' + body.email)
                } else {

                    setShowErrorMessage(true)
                    setErrorMessage(err)
                    setLogin(prev => ({ ...prev, password: '' }))
                    setValidate(true)
                    setTimeout(() => {
                        setShowErrorMessage(false)
                    }, 3000);
                }

            })
        } else {
            setValidate(true)
        }

    }

    const goToHelp = () => {

        let helpUrl = configs?.help_page.replace('{{lang}}', configs?.language.iso_code)

        window.open(helpUrl)
        // window.location.href = helpUrl

    }
    if (signingIn) return <Loading />

    return (
        <>
            <ErrorMessage text={errorMessage} type={'error'} show={showErrorMessage} />
            <div className="login">
                <form onSubmit={onSubmit} action="">
                    <label htmlFor="">{translateWord('email', 'E-Mail')}:</label>
                    <input className={validate && !login.email ? 'not_valid' : ''} type="text" value={login.email}
                        name={'email'} onChange={onChange} />
                    <label htmlFor="">{translateWord('password', 'Password')}:</label>
                    <input className={validate && !login.password ? 'not_valid' : ''} type="password"
                        value={login.password} name={'password'} onChange={onChange} />
                    <NavLink to={'/auth/forgot-password'} className='forgot_password'> {translateWord('Forgot Password?', 'Forgot Password?')} </NavLink>
                    <button type={'submit'} className={'card_color'}>{translateWord('login', 'Login')}</button>
                    <p>
                        {translateWord('If you have not account', 'If you have not account')}, {" "}
                        <NavLink to={'/auth'}>{translateWord('Register Now', 'Register Now')} </NavLink>
                    </p>
                    <p>
                        {translateWord('Need help? ', 'Need help? ')}
                        <span onClick={goToHelp}>{translateWord('Go to Help', 'Go to Help')}</span>
                    </p>
                </form>
            </div>
        </>
    )
}